//Common keyboard event handlers for accessibility

export const bindKeyboardEvents = (onClick) => (event) => {
  const isEnterOrSpace = event.key === 'Enter' || event.key === ' ';
  if (isEnterOrSpace) {
    event.preventDefault();
    const input = event?.currentTarget?.querySelector('input');
    if (input && onClick) {
      input.click();
    } else if (onClick) {
      onClick();
    }
  }
};

// Keyboard navigation for dropdown components

const dispatchMouseEvent = (element, eventType) => {
  const mouseEvent = new MouseEvent(eventType, {
    bubbles: true,
    cancelable: true,
    view: window
  });
  element.dispatchEvent(mouseEvent);
};

export const handleDropdownKeyboardNavigation = (onValueSelect, config = {}) => (event) => {
  const {
    allowArrowKeys = true,
    allowEnterSelect = true,
    allowSpaceToOpen = true,
    allowEscapeToClose = true,
    onOpenDropdown,
    onCloseDropdown,
  } = config;

  const dropdownElement =
    event?.target?.tagName === 'SELECT'
      ? event?.target
      : event?.currentTarget?.querySelector('select');

  if (!dropdownElement) return;

  switch (event.key) {
    case 'Enter':
      if (allowEnterSelect) {
        event.preventDefault();
        onValueSelect?.(dropdownElement.value);
      }
      break;
    case ' ':
      if (allowSpaceToOpen) {
        event.preventDefault();
        event.stopPropagation();

        dropdownElement.focus();

        try {
          if (dropdownElement.showPicker && typeof dropdownElement.showPicker === 'function') {
            dropdownElement.showPicker();
          } else {
            dispatchMouseEvent(dropdownElement, 'click');
          }
        } catch (error) {
          dispatchMouseEvent(dropdownElement, 'mousedown');
        }

        onOpenDropdown?.();
      }
      break;
    case 'Escape':
      if (allowEscapeToClose) {
        event.preventDefault();
        dropdownElement.blur();
        onCloseDropdown?.();
      }
      break;
    case 'ArrowDown':
    case 'ArrowUp':
      if (allowArrowKeys) {
        if (dropdownElement.matches(':focus')) {
        // Slight delay
          setTimeout(() => onValueSelect?.(dropdownElement.value), 0);
        } else {
          event.preventDefault();
        }
      }
      break;
    default:
      break;
  }
};